import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Tooltip } from '@mui/material';
import MUICustomModal from '../../components/atoms/modal';
import {
  boldFont,
  commentStyle,
  VSInfoGrid,
  VSInfoValue,
  VSModalHeader,
  VSModalJustification,
} from '../../styles';
import { includeNegativeForCostImpact } from '../../utils';
import InputTextField from '../../components/atoms/input-field/inputTextField';
import InputTextAreaField from '../../components/atoms/input-field/inputTextAreaField';

//Value Score Adjustment Modal
const ValueScoreAdjustmentModal = props => {
  const { t } = useTranslation();
  const {
    openVSAdjustmentModal = false,
    onSaveClick = () => {},
    onCancelClick = () => {},
    onBackDropClick = () => {},
    adjustmentModalData = {},
    handleModalChange = () => {},
    inputValidationMessage = '',
  } = props;

  //destructuring adjustmentModalData prop
  const {
    Title,
    Description,
    CalculatedValue,
    SiteName,
    ManagerValueAdjustment,
    ManagerComments,
  } = adjustmentModalData;

  return (
    <MUICustomModal
      open={openVSAdjustmentModal}
      modalWidth={600}
      onSecondoryButtonClick={onSaveClick}
      onPrimaryButton={onCancelClick}
      disableSecondoryButton={
        ManagerValueAdjustment === null ||
        ManagerValueAdjustment === '' ||
        ManagerComments === '' ||
        ManagerComments === null ||
        inputValidationMessage !== ''
      }
      onBackDropClick={onBackDropClick}
    >
      <Grid>
        <Grid style={VSModalHeader}>
          {t('PECR_Value_Score_Adjustment', { PECR: 'P/ECR' })}
        </Grid>
        <Grid
          style={{
            display: 'flex',
            marginTop: '35px',
            flexDirection: 'column',
          }}
        >
          <Grid style={VSInfoGrid}>
            <Grid style={boldFont}>{`${t('Title')}:`}</Grid>
            <Grid>
              <Tooltip
                key={'title'}
                title={Title}
                componentsProps={{
                  tooltip: {
                    sx: {
                      fontSize: '17px',
                    },
                  },
                }}
              >
                <Grid key={'title'} style={VSInfoValue} width={500}>
                  {Title}
                </Grid>
              </Tooltip>
            </Grid>
          </Grid>
          <Grid style={VSInfoGrid}>
            <Grid style={boldFont}>{`${t('Description')}:`}</Grid>
            <Grid>
              <Tooltip
                key={'Description'}
                title={Description}
                componentsProps={{
                  tooltip: {
                    sx: {
                      fontSize: '17px',
                    },
                  },
                }}
              >
                <Grid key={'Description'} style={VSInfoValue} width={450}>
                  {Description}
                </Grid>
              </Tooltip>
            </Grid>
          </Grid>
          <Grid style={VSInfoGrid}>
            <Grid style={boldFont}>{`${t('Value_Base_Score')}:`}</Grid>
            <Grid>{CalculatedValue}</Grid>
          </Grid>
          <Grid style={VSInfoGrid}>
            <Grid style={boldFont}>
              {`${t('PECR_Value_Score_Adjustment', { PECR: SiteName })}:`}
            </Grid>
            <Grid width={90}>
              <InputTextField
                name={'ManagerValueAdjustment'}
                placeholder={t('Score')}
                style={{
                  border: '1px solid gray',
                  padding: '0px 5px',
                  borderRadius: '5px',
                }}
                type={'number'}
                value={ManagerValueAdjustment}
                onKeyDown={e =>
                  includeNegativeForCostImpact.includes(e.key) &&
                  e.preventDefault()
                }
                onChange={handleModalChange}
              />
            </Grid>
          </Grid>
          <Grid style={VSModalJustification}>
            <InputTextAreaField
              name={'ManagerComments'}
              placeholder={`${t('Provide_Score_Adjustment_Justification')}...`}
              onChange={handleModalChange}
              customStyle={commentStyle}
              value={ManagerComments}
              error={inputValidationMessage}
            />
          </Grid>
        </Grid>
      </Grid>
    </MUICustomModal>
  );
};

export default ValueScoreAdjustmentModal;
